import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { getUser, saveUser as setUser } from '../auth';

const SPECIALITES = [
  { emoji: '⚽', label: 'Sport Coaching' },
  { emoji: '🍳', label: 'Cuisine Patisserie' },
  { emoji: '🎨', label: 'Art Creatif' },
  { emoji: '🌿', label: 'Nature Outdoor' },
  { emoji: '🔬', label: 'Sciences' },
  { emoji: '🎭', label: 'Theatre Cirque' },
  { emoji: '🎸', label: 'Musique' },
  { emoji: '🏕️', label: 'Survie Aventure' },
  { emoji: '🚴', label: 'Velo VTT' },
  { emoji: '📚', label: 'Educatif' },
  { emoji: '🐟', label: 'Peche Riviere' },
  { emoji: '🧘', label: 'Bien-etre' },
];

export default function InscriptionPro() {
  const navigate = useNavigate();
  const user = getUser();
  const [step, setStep] = useState(user ? 2 : 1);
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');

  const [prenom, setPrenom] = useState(user?.prenom || '');
  const [telephone, setTelephone] = useState('');
  const [code, setCode] = useState('');
  const [codeEnvoye, setCodeEnvoye] = useState(false);

  const [specialite, setSpecialite] = useState('');
  const [bio, setBio] = useState('');
  const [contact, setContact] = useState('');

  const [titreActivite, setTitreActivite] = useState('');
  const [description, setDescription] = useState('');
  const [duree, setDuree] = useState(90);
  const [ageMin, setAgeMin] = useState(4);
  const [ageMax, setAgeMax] = useState(12);
  const [nbMin, setNbMin] = useState(5);
  const [nbMax, setNbMax] = useState(15);
  const [prixEnfant, setPrixEnfant] = useState(0);
  const [materielFourni, setMaterielFourni] = useState('');
  const [materielApporter, setMaterielApporter] = useState('');

  const [documentUploaded, setDocumentUploaded] = useState(false);
  const [documentFile, setDocumentFile] = useState(null);

  const envoyerCode = async () => {
    if (!prenom.trim()) { setErreur('Entre ton prenom'); return; }
    if (!telephone.trim()) { setErreur('Entre ton numero'); return; }
    setLoading(true); setErreur('');
    const tel = telephone.startsWith('+') ? telephone : '+33' + telephone.replace(/^0/, '');
    const { error } = await supabase.auth.signInWithOtp({ phone: tel });
    if (error) setErreur('Erreur envoi SMS');
    else setCodeEnvoye(true);
    setLoading(false);
  };

  const verifierCode = async () => {
    if (!code.trim()) { setErreur('Entre le code'); return; }
    setLoading(true); setErreur('');
    const tel = telephone.startsWith('+') ? telephone : '+33' + telephone.replace(/^0/, '');
    const { data, error } = await supabase.auth.verifyOtp({ phone: tel, token: code, type: 'sms' });
    if (error) { setErreur('Code incorrect'); setLoading(false); return; }
    const { data: existing } = await supabase.from('users').select('*').eq('id', data.user.id).single();
    if (!existing) {
      await supabase.from('users').insert({ id: data.user.id, prenom: prenom.trim(), telephone: tel });
    }
    const { data: userData } = await supabase.from('users').select('*').eq('id', data.user.id).single();
    setUser(userData);
    setStep(2);
    setLoading(false);
  };

  const uploadDocument = async (file) => {
    if (!file) return;
    const currentUser = getUser();
    if (!currentUser) return;
    const ext = file.name.split('.').pop();
    const path = `documents/${currentUser.id}/diplome.${ext}`;
    const { error } = await supabase.storage.from('photos').upload(path, file, { upsert: true });
    if (!error) { setDocumentUploaded(true); setDocumentFile(file); }
  };

  const finaliser = async () => {
    const currentUser = getUser();
    if (!currentUser) return;
    setLoading(true);

    await supabase.from('users').update({
      is_pro: true,
      bio: bio.trim(),
      specialite,
      contact_pro: contact.trim(),
      documents_fournis: documentUploaded,
    }).eq('id', currentUser.id);

    if (titreActivite.trim()) {
      const typeMap = {
        'Sport Coaching': 'Sport',
        'Nature Outdoor': 'Nature',
        'Art Creatif': 'Creatif',
        'Survie Aventure': 'Nature',
        'Velo VTT': 'Sport',
      };
      await supabase.from('activites').insert({
        titre: titreActivite.trim(),
        type: typeMap[specialite] || 'Jeux',
        emoji: SPECIALITES.find(s => s.label === specialite)?.emoji || '🌿',
        lieu: 'France',
        description: description.trim(),
        age_min: ageMin,
        age_max: ageMax,
        max_familles: nbMax,
        max_enfants: nbMax,
        nb_enfants_min: nbMin,
        nb_enfants_max: nbMax,
        is_payante: prixEnfant > 0,
        prix_enfant: prixEnfant,
        parents_obligatoires: true,
        materiel_fourni: materielFourni.trim(),
        materiel_apporter: materielApporter.trim(),
        duree_minutes: duree,
        user_id: currentUser.id,
        date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        heure: '10:00',
      });
    }

    await supabase.from('notifications').insert({
      user_id: '844324a7-263b-45cd-9e15-8978820e1972',
      type: 'nouveau_pro',
      message: `Nouveau pro : ${currentUser.prenom} — ${specialite} — ${documentUploaded ? 'Documents fournis' : 'Sans documents'}`,
      lu: false,
    });

    setLoading(false);
    setStep(5);
  };

  const ProgressBar = () => (
    <div style={{ display: 'flex', gap: 4, padding: '16px 24px 0', maxWidth: 420, margin: '0 auto' }}>
      {[1, 2, 3, 4].map(s => (
        <div key={s} style={{ flex: 1, height: 4, borderRadius: 100, background: s < step ? '#3D9A6A' : s === step ? '#3D9A6A' : '#E8EFE9', opacity: s < step ? 0.5 : 1 }} />
      ))}
    </div>
  );

  const Header = ({ titre, sous }) => (
    <div style={{ padding: '20px 24px 0', maxWidth: 420, margin: '0 auto' }}>
      <button onClick={() => step > 1 ? setStep(step - 1) : navigate('/pro')} style={{ background: '#EDF7F1', border: 'none', borderRadius: 100, padding: '8px 16px', color: '#3D9A6A', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer', marginBottom: 16 }}>← Retour</button>
      <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.4rem', color: '#1C2B1E', marginBottom: 6 }}>{titre}</div>
      {sous && <div style={{ fontSize: '0.85rem', color: '#8A9E8D', lineHeight: 1.6, marginBottom: 20 }}>{sous}</div>}
    </div>
  );

  if (step === 1) return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7' }}>
      <ProgressBar />
      <div style={{ padding: '0 24px 80px', maxWidth: 420, margin: '0 auto' }}>
        <Header titre="Cree ton compte" sous="Juste ton prenom et ton numero pour commencer" />
        <div style={{ background: 'white', borderRadius: 24, padding: '24px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)' }}>
          {!codeEnvoye ? (
            <>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ton prenom</label>
                <input value={prenom} onChange={e => setPrenom(e.target.value)} placeholder="Ex: Thomas"
                  style={{ width: '100%', padding: '14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '1rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ton numero</label>
                <input value={telephone} onChange={e => setTelephone(e.target.value)} placeholder="06 12 34 56 78" type="tel"
                  style={{ width: '100%', padding: '14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '1rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }} />
              </div>
              {erreur && <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 14 }}>{erreur}</div>}
              <button onClick={envoyerCode} disabled={loading} style={{ width: '100%', padding: '16px', background: loading ? '#E8EFE9' : '#3D9A6A', color: loading ? '#8A9E8D' : 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer' }}>
                {loading ? 'Envoi...' : '📱 Recevoir mon code SMS'}
              </button>
            </>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <div style={{ fontSize: '2rem', marginBottom: 8 }}>📱</div>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 4 }}>Code envoye !</div>
                <div style={{ fontSize: '0.82rem', color: '#8A9E8D' }}>Entre le code recu par SMS</div>
              </div>
              <input value={code} onChange={e => setCode(e.target.value)} placeholder="123456" type="number"
                style={{ width: '100%', padding: '16px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '1.5rem', textAlign: 'center', letterSpacing: 8, marginBottom: 16, outline: 'none', boxSizing: 'border-box' }} />
              {erreur && <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 14 }}>{erreur}</div>}
              <button onClick={verifierCode} disabled={loading} style={{ width: '100%', padding: '16px', background: loading ? '#E8EFE9' : '#3D9A6A', color: loading ? '#8A9E8D' : 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer' }}>
                {loading ? 'Verification...' : '✅ Valider'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );

  if (step === 2) return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7' }}>
      <ProgressBar />
      <div style={{ padding: '0 24px 80px', maxWidth: 420, margin: '0 auto' }}>
        <Header titre="Qui es-tu ? 👋" sous="Presente-toi aux familles. Sois authentique !" />
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 12, display: 'block' }}>Ta specialite</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {SPECIALITES.map((s, i) => (
              <div key={i} onClick={() => setSpecialite(s.label)}
                style={{ padding: '8px 14px', borderRadius: 100, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 700, border: '2px solid', borderColor: specialite === s.label ? '#3D9A6A' : '#E8EFE9', background: specialite === s.label ? '#EDF7F1' : 'white', color: specialite === s.label ? '#3D9A6A' : '#4A6355' }}>
                {s.emoji} {s.label}
              </div>
            ))}
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Presente-toi en 2-3 lignes</label>
          <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 10 }}>Ex: "Je suis educateur sportif depuis 8 ans, passionne de football."</div>
          <textarea value={bio} onChange={e => setBio(e.target.value)} placeholder="Qui tu es, ton experience, pourquoi tu aimes ca..."
            rows={4} style={{ width: '100%', padding: '12px 14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.9rem', outline: 'none', background: '#FAFAF7', resize: 'none', boxSizing: 'border-box' }} />
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 24 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Comment te contacter ?</label>
          <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 10 }}>WhatsApp, email — les familles t ecriront directement</div>
          <input value={contact} onChange={e => setContact(e.target.value)} placeholder="Ex: 06 12 34 56 78 ou email@exemple.fr"
            style={{ width: '100%', padding: '14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.9rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }} />
        </div>
        {erreur && <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 12, textAlign: 'center' }}>{erreur}</div>}
        <button onClick={() => {
          if (!specialite) { setErreur('Choisis ta specialite'); return; }
          if (!bio.trim()) { setErreur('Presente-toi en quelques lignes'); return; }
          if (!contact.trim()) { setErreur('Indique comment te contacter'); return; }
          setErreur(''); setStep(3);
        }} style={{ width: '100%', padding: '17px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer', boxShadow: '0 6px 20px rgba(61,154,106,0.3)' }}>
          Continuer →
        </button>
      </div>
    </div>
  );

  if (step === 3) return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7' }}>
      <ProgressBar />
      <div style={{ padding: '0 24px 80px', maxWidth: 420, margin: '0 auto' }}>
        <Header titre="Ton activite 🎯" sous="Decris precisement ce que tu proposes." />
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Titre de l activite</label>
          <input value={titreActivite} onChange={e => setTitreActivite(e.target.value)} placeholder="Ex: Initiation football pour enfants"
            style={{ width: '100%', padding: '14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.95rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }} />
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Description</label>
          <textarea value={description} onChange={e => setDescription(e.target.value)}
            placeholder="Qu est-ce que les enfants vont faire ? Apprendre ? Vivre ?"
            rows={4} style={{ width: '100%', padding: '12px 14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.88rem', outline: 'none', background: '#FAFAF7', resize: 'none', boxSizing: 'border-box' }} />
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 12, display: 'block' }}>Duree</label>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {[60, 90, 120, 150, 180].map(d => (
              <button key={d} onClick={() => setDuree(d)} style={{ padding: '10px 16px', borderRadius: 100, border: '2px solid', borderColor: duree === d ? '#3D9A6A' : '#E8EFE9', background: duree === d ? '#EDF7F1' : 'white', color: duree === d ? '#3D9A6A' : '#8A9E8D', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer' }}>
                {d === 60 ? '1h' : d === 90 ? '1h30' : d === 120 ? '2h' : d === 150 ? '2h30' : '3h'}
              </button>
            ))}
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 12, display: 'block' }}>Age des enfants</label>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 6 }}>Age minimum</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button onClick={() => setAgeMin(Math.max(2, ageMin - 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#F3F4F2', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>−</button>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#3D9A6A', minWidth: 40, textAlign: 'center' }}>{ageMin}</div>
                <button onClick={() => setAgeMin(Math.min(ageMax - 1, ageMin + 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#3D9A6A', border: 'none', cursor: 'pointer', fontSize: '1rem', color: 'white' }}>+</button>
              </div>
            </div>
            <div style={{ color: '#8A9E8D', fontWeight: 700 }}>→</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 6 }}>Age maximum</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button onClick={() => setAgeMax(Math.max(ageMin + 1, ageMax - 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#F3F4F2', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>−</button>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#3D9A6A', minWidth: 40, textAlign: 'center' }}>{ageMax}</div>
                <button onClick={() => setAgeMax(Math.min(18, ageMax + 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#3D9A6A', border: 'none', cursor: 'pointer', fontSize: '1rem', color: 'white' }}>+</button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4, display: 'block' }}>Nombre d enfants</label>
          <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 12 }}>L activite n a lieu que si le minimum est atteint</div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 6 }}>Minimum</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button onClick={() => setNbMin(Math.max(2, nbMin - 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#F3F4F2', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>−</button>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#FF7043', minWidth: 40, textAlign: 'center' }}>{nbMin}</div>
                <button onClick={() => setNbMin(Math.min(nbMax - 1, nbMin + 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#FF7043', border: 'none', cursor: 'pointer', fontSize: '1rem', color: 'white' }}>+</button>
              </div>
            </div>
            <div style={{ color: '#8A9E8D', fontWeight: 700 }}>→</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 6 }}>Maximum</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button onClick={() => setNbMax(Math.max(nbMin + 1, nbMax - 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#F3F4F2', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>−</button>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#FF7043', minWidth: 40, textAlign: 'center' }}>{nbMax}</div>
                <button onClick={() => setNbMax(Math.min(50, nbMax + 1))} style={{ width: 36, height: 36, borderRadius: '50%', background: '#FF7043', border: 'none', cursor: 'pointer', fontSize: '1rem', color: 'white' }}>+</button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4, display: 'block' }}>Prix par enfant</label>
          <div style={{ fontSize: '0.75rem', color: '#8A9E8D', marginBottom: 12 }}>Mets 0 si gratuit. Paiement direct entre toi et les familles.</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button onClick={() => setPrixEnfant(Math.max(0, prixEnfant - 1))} style={{ width: 44, height: 44, borderRadius: '50%', background: '#F3F4F2', border: 'none', cursor: 'pointer', fontSize: '1.2rem' }}>−</button>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2rem', color: prixEnfant > 0 ? '#3D9A6A' : '#8A9E8D' }}>
                {prixEnfant === 0 ? 'Gratuit' : prixEnfant + 'euros'}
              </div>
              {prixEnfant > 0 && <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>par enfant · paye sur place</div>}
            </div>
            <button onClick={() => setPrixEnfant(Math.min(100, prixEnfant + 1))} style={{ width: 44, height: 44, borderRadius: '50%', background: '#3D9A6A', border: 'none', cursor: 'pointer', fontSize: '1.2rem', color: 'white' }}>+</button>
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '20px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16 }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ce que tu fournis</label>
          <input value={materielFourni} onChange={e => setMaterielFourni(e.target.value)} placeholder="Ex: Ballons, dossards, cones"
            style={{ width: '100%', padding: '12px 14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.88rem', outline: 'none', background: '#FAFAF7', marginBottom: 12, boxSizing: 'border-box' }} />
          <label style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ce que les familles doivent apporter</label>
          <input value={materielApporter} onChange={e => setMaterielApporter(e.target.value)} placeholder="Ex: Tenue de sport, bouteille d eau"
            style={{ width: '100%', padding: '12px 14px', border: '2px solid #E8EFE9', borderRadius: 14, fontFamily: 'Nunito, sans-serif', fontSize: '0.88rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }} />
        </div>
        <div style={{ background: '#EDF7F1', borderRadius: 20, padding: '16px', marginBottom: 24, display: 'flex', gap: 12 }}>
          <span style={{ fontSize: '1.4rem' }}>👨‍👩‍👧</span>
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 4 }}>Regle Wooki obligatoire</div>
            <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.6 }}>Les parents doivent rester presents pendant toute la duree de l activite.</div>
          </div>
        </div>
        {erreur && <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 12, textAlign: 'center' }}>{erreur}</div>}
        <button onClick={() => {
          if (!titreActivite.trim()) { setErreur('Entre un titre'); return; }
          if (!description.trim()) { setErreur('Decris ton activite'); return; }
          setErreur(''); setStep(4);
        }} style={{ width: '100%', padding: '17px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer', boxShadow: '0 6px 20px rgba(61,154,106,0.3)' }}>
          Continuer →
        </button>
      </div>
    </div>
  );

  if (step === 4) return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7' }}>
      <ProgressBar />
      <div style={{ padding: '0 24px 80px', maxWidth: 420, margin: '0 auto' }}>
        <Header titre="Tes documents 📋" sous="Optionnel mais recommande — ca rassure les familles." />
        <div style={{ background: '#EDF7F1', borderRadius: 20, padding: '16px', marginBottom: 20 }}>
          <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.6 }}>
            Les documents sont fournis sous ta responsabilite. Wooki les affiche mais ne verifie pas leur authenticite.
          </div>
        </div>
        <div style={{ background: 'white', borderRadius: 24, padding: '24px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 16, textAlign: 'center' }}>
          {!documentUploaded ? (
            <>
              <div style={{ fontSize: '3rem', marginBottom: 12 }}>📄</div>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 8 }}>Upload un document</div>
              <div style={{ fontSize: '0.82rem', color: '#8A9E8D', lineHeight: 1.6, marginBottom: 20 }}>Diplome, certification, assurance RC Pro...</div>
              <label style={{ display: 'block', padding: '14px', background: '#EDF7F1', color: '#3D9A6A', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '0.9rem', cursor: 'pointer', border: '2px dashed #C5DFC9' }}>
                📁 Choisir un fichier
                <input type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={e => uploadDocument(e.target.files[0])} />
              </label>
            </>
          ) : (
            <>
              <div style={{ fontSize: '3rem', marginBottom: 12 }}>✅</div>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#3D9A6A', marginBottom: 8 }}>Document fourni !</div>
              <div style={{ fontSize: '0.82rem', color: '#8A9E8D', marginBottom: 12 }}>{documentFile?.name}</div>
              <div style={{ background: '#EDF7F1', borderRadius: 12, padding: '8px 14px', display: 'inline-block', fontSize: '0.78rem', color: '#4A6355', fontWeight: 700 }}>
                📋 Documents fournis par l organisateur
              </div>
            </>
          )}
        </div>
        <button onClick={finaliser} disabled={loading} style={{ width: '100%', padding: '17px', background: loading ? '#E8EFE9' : '#3D9A6A', color: loading ? '#8A9E8D' : 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 12, boxShadow: '0 6px 20px rgba(61,154,106,0.3)' }}>
          {loading ? 'Publication...' : '🚀 Publier mon activite !'}
        </button>
        <button onClick={finaliser} style={{ width: '100%', padding: '13px', background: 'transparent', color: '#8A9E8D', border: 'none', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer' }}>
          Continuer sans document →
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', textAlign: 'center' }}>
      <style>{`@keyframes pop{0%{transform:scale(0);opacity:0}70%{transform:scale(1.2)}100%{transform:scale(1);opacity:1}}`}</style>
      <div style={{ fontSize: '5rem', marginBottom: 16, animation: 'pop 0.6s cubic-bezier(0.34,1.56,0.64,1) forwards' }}>🎉</div>
      <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.8rem', color: '#1C2B1E', marginBottom: 8 }}>Ton profil est en ligne !</div>
      <div style={{ fontSize: '0.9rem', color: '#8A9E8D', lineHeight: 1.7, maxWidth: 320, marginBottom: 28 }}>
        Ton activite est maintenant visible par les familles pres de chez toi !
      </div>
      <div style={{ background: 'white', borderRadius: 24, padding: '20px', width: '100%', maxWidth: 380, boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 20, textAlign: 'left' }}>
        {[
          { icon: '✅', label: 'Profil cree', val: 'Visible par les familles' },
          { icon: '📋', label: 'Documents', val: documentUploaded ? 'Fournis' : 'Non fournis — a ajouter plus tard' },
          { icon: '👨‍👩‍👧', label: 'Regle parents', val: 'Presents obligatoires' },
          { icon: '📞', label: 'Contact', val: 'Les familles t ecriront directement' },
        ].map((r, i, arr) => (
          <div key={i} style={{ display: 'flex', gap: 12, padding: '10px 0', borderBottom: i < arr.length - 1 ? '1px solid #F3F4F2' : 'none' }}>
            <span style={{ fontSize: '1.1rem' }}>{r.icon}</span>
            <div>
              <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>{r.label}</div>
              <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1C2B1E' }}>{r.val}</div>
            </div>
          </div>
        ))}
      </div>
      <button onClick={() => navigate('/feed')} style={{ width: '100%', maxWidth: 380, padding: '17px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer', marginBottom: 12, boxShadow: '0 6px 20px rgba(61,154,106,0.35)' }}>
        🌿 Voir mon activite dans le feed
      </button>
      <button onClick={() => navigate('/profil')} style={{ width: '100%', maxWidth: 380, padding: '14px', background: '#EDF7F1', color: '#3D9A6A', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer' }}>
        👤 Voir mon profil
      </button>
    </div>
  );
}